import {
  NEW_RULE_PARAM_VALUE,
  useOpenAgenticLogicTakeover,
} from "@src/features/ai/pages/agentic-logic/embedded/takeoverEntry";
import { AgenticLogicBindingFields } from "@src/features/sharedExperience/components/agenticLogic/AgenticLogicBindingFields";
import type {
  BundleOnsiteUpsellComponent,
  OnsiteUpsellComponent,
} from "@src/store/slices/experienceBuilder/types";

interface AgenticLogicSectionProps {
  mod: OnsiteUpsellComponent | BundleOnsiteUpsellComponent;
  onChange: (
    changes: Pick<OnsiteUpsellComponent, "agenticLogicRuleId">
  ) => void;
}

/**
 * The onsite counterpart of the checkout block's binding editor: bind this
 * upsell component to an Agentic Logic rule, see what the binding resolves to,
 * and clear it.
 *
 * Renders under the panel's own "Rules" header, and for an engine org it is
 * the ONLY rules editor — a rule selection is required, enforced by the
 * panel's Apply gate.
 */
export const AgenticLogicSection = ({
  mod,
  onChange,
}: AgenticLogicSectionProps) => {
  const openTakeover = useOpenAgenticLogicTakeover();
  return (
    <AgenticLogicBindingFields
      placementId={mod.agenticLogicPlacementId ?? null}
      ruleId={mod.agenticLogicRuleId ?? null}
      variationId={mod.variationId}
      surface="onsite"
      onCreateRule={() => openTakeover(NEW_RULE_PARAM_VALUE)}
      onEditRule={openTakeover}
      onRuleChange={(agenticLogicRuleId: string) =>
        onChange({ agenticLogicRuleId })
      }
      // The built-in Shopify recommendations rule is scoped to Checkout >
      // Upsell blocks; onsite components offer only the store's own rules.
      builtInRule={null}
    />
  );
};
